import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import withPDFViewer from "../components/withPDFViewer";
import { Box, Heading, Text } from "@chakra-ui/react";
import BtechCollegeDetails from "../components/sections/BtechCollegeDetails";
import { b_tech_college } from "../collegesData/btechData";
import DeemedCollegeDetails from "../components/sections/DeemedCollegeDetails";

const PDFViewer = withPDFViewer(() => null);

const DeemedCollegeDetailsPage = () => {
 const location = useLocation();
 const { college } = location.state || {};
 console.log("pdf:", college);

 // inside component
 useEffect(() => {
  if (location.state) {
   console.log("PDF from state:", location.state.college);
  } else {
   console.log("No location.state — possibly refreshed or accessed directly.");
  }
 }, [location.state]);

 return (
  <Box bg="gray.100" minH="100vh" py={8}>
   <Box maxW="container.xl" mx="auto" px={4}>
    <DeemedCollegeDetails college={college} />
   </Box>
  </Box>
 );
};

export default DeemedCollegeDetailsPage;
